<template>
  <div class="table offer-info">
    <el-form ref="form" :model="c_data">
      <el-table :data="c_data" ref="dataTable" border style="margin-top: 10px ;">
        <el-table-column :selectable="(row)=>row.productDescription != 'Warehouse'" v-if="canEdit" align="center" type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip label="Product Description" prop="productDescription"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="supplierDc" label="Supplied Dc" width="200px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].supplierDc`" :rules="dcRule">
              <el-select @change="changeDcs(scope.$index)" v-model="scope.row.supplierDc" :disabled="!c_canEdit || scope.row.productDescription == 'Warehouse'" multiple>
                <el-option v-for="(item,index) in dcList" :label="item.dcName" :value="item.tmDcId"></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip  prop="adpWithoutVat" label="ADP Without VAT">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].adpWithoutVat`" :rules="[requireRule,priceRule]">
              <el-input v-model="scope.row.adpWithoutVat" :disabled="!canEdit"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="VAT(RMB/Per case)">
          <template slot-scope="scope">{{getVat(scope.$index)}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="ADP included VAT">
          <template slot-scope="scope">{{getAdpIncludeVat(scope.$index)}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="vatRate" label="VAT Rate">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].vatRate`" :rules="requiredRule">
              <ic-select :disabled="!canEdit" table="TT_FPA_PCN" field="VAT_RATE" v-model="scope.row.vatRate"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="priceEffectiveDateFrom" label="PriceEffectiveDateFrom">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].priceEffectiveDateFrom`" :rules="requiredRule">
              <el-date-picker :picker-options="{disabledDate:maxData(scope.row.priceEffectiveDateTo)}" :disabled="!canEdit" value-format="yyyy-MM-dd" v-model="scope.row.priceEffectiveDateFrom" type="date" :placeholder="'Select Date'"></el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="priceEffectiveDateTo" label="PriceEffectiveDateTo">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].priceEffectiveDateTo`" :rules="requiredRule">
              <el-date-picker :picker-options="{disabledDate:minDate(scope.row.priceEffectiveDateFrom)}" :disabled="!canEdit" value-format="yyyy-MM-dd" v-model="scope.row.priceEffectiveDateTo" type="date" :placeholder="'Select Date'"></el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>
<script>
import { Message } from "element-ui";
import commonMethods from "@/utils/commonMethods";
import commonFun from "@/utils/commonFun";
import supplier from "@/api/supplier/supplier";
import DC from "@/api/DC/DC";
import IcSelect from "@/components/common/icSelect";
import moment from "moment";

export default {
  name: 'pcn-table',
  extends: commonMethods,
  components: { IcSelect },
  props: {
    data: Array,
    canEdit: Boolean
  },
  computed: {
    canEditFreightForcast() {
      return false;
      // let functionCode = null;
      // if (this.$store.state.ssr.data.type == "SSR") {
      //     functionCode = "Input SSR logistic Info";
      // } else if (this.$store.state.ssr.data.type == "RFP") {
      //     functionCode = "Input RFP logistic Info";
      // }
      // return commonFun.havePermission(functionCode);
    },
    changeDcs(index) {
      let that = this;
      return (index) => {
        let selectRow = that.c_data[index];
        that.c_data.filter((row, i) => (i != index) && (selectRow.groupId == row.groupId))[0].supplierDc = selectRow.supplierDc;
      }
    },
    getVat(index) {
      let that = this;
      return (index) => {
        let row = that.c_data[index];
        if (commonFun.isNotEmpty(row.adpWithoutVat) && commonFun.isNotEmpty(row.vatRate)) {
          return (row.adpWithoutVat * (row.vatRate / 100)).toFixed(6);
        }
      };
    },
    getAdpIncludeVat(index) {
      let that = this;
      return (index) => {
        let row = that.c_data[index];
        if (commonFun.isNotEmpty(row.adpWithoutVat) && commonFun.isNotEmpty(row.vatRate)) {
          return (row.adpWithoutVat * (1 + (row.vatRate / 100))).toFixed(6);
        }
      };
    }
  },
  data() {
    return {
      c_canEdit: false,
      c_data: [],
      plantList: [],
      dcList: [],

      requiredRule: [{ required: true, message: 'Can not be empty!', trigger: 'blur' }],
      requireRule: { required: true, message: 'Can not be empty!', trigger: 'blur' },
      priceRule: {
        required: true, validator: (rule, value, callback) => {
          if (isNaN(value) || value < 0) {
            callback('Number error!');
          }
          if (commonFun.isNotEmpty(value)) {
            let arr = (value + "").split(".");
            if (arr.length == 2 && arr[1].length > 6) {
              callback('Please enter up to 6 decimal places');
            }
          }
          callback();
        }, trigger: 'blur'
      },
      numberRule: {
        required: true, validator: (rule, value, callback) => {
          if (isNaN(value) || value < 0) {
            callback('Number error!');
          }
          callback();
        }, trigger: 'blur'
      },
      dcRule: [{
        required: true, validator: (rule, value, callback) => {
          let arr = null;
          if (typeof value == "string") {
            arr = JSON.parse(value);
          } else {
            arr = value;
          }
          if (arr.length == 0) {
            callback(new Error('Can not be empty!'));
          } else {
            callback();
          }
        }, trigger: 'blur'
      }]
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    maxData(maxDate) {
      return (val) => {
        if (maxDate != null) {
          return moment(val).diff(moment(maxDate)) > 0;
        } else {
          return false;
        }
      }
    },
    minDate(minDate) {
      return (val) => {
        if (minDate != null) {
          return moment(val).diff(moment(minDate)) < 0;
        } else {
          return false;
        }
      }
    },
    init() {
      this.c_canEdit = this.canEdit;
      this.c_data = this.data;
      let that = this;
      if (this.canEdit) {
        supplier.getMyPlantList().then(res => {
          that.plantList = res.data;
        });
      }
      DC.listAllDc({}).then(res => {
        that.dcList = res.data;
      });
    },
    delSelect() {
      let selectRows = this.$refs.dataTable.selection;
      if (selectRows.length == 0) {
        Message.warning('Please select data!');
      }
      let that = this;
      selectRows.forEach(row => {
        this.c_data.filter(tmp => tmp.groupId == row.groupId).forEach(tmp => {
          that.c_data.splice(that.c_data.findIndex(tmp1 => tmp == tmp1), 1);
        });
      });
    },
  },
  watch: {
    data() {
      this.init();
    },
    canEdit(val) {
      this.c_canEdit = this.canEdit;
    },
    c_data(val) {
      this.$emit("update:data", this.c_data);
    }
  }
}
</script>
<style scoped>
/*.el-form-item--mini.el-form-item:not(.is-error), .el-form-item--small.el-form-item:not(.is-error){*/
/*    margin-bottom: 0;*/
/*}*/
</style>
